/**
 * Sizing guide overlay.
 *
 * A native dialog, so focus trapping, Escape and the backdrop come from the
 * browser rather than being reimplemented.
 */

function modalFor(trigger) {
  const scope = trigger.closest('.footwear-sizing');
  return scope ? scope.querySelector('[data-sizing-guide-modal]') : null;
}

document.addEventListener('click', (event) => {
  const open = event.target.closest('[data-sizing-guide-open]');
  if (open) {
    event.preventDefault();
    const modal = modalFor(open);
    if (modal instanceof HTMLDialogElement) modal.showModal();
    return;
  }

  const close = event.target.closest('[data-sizing-guide-close]');
  if (close) {
    event.preventDefault();
    close.closest('dialog')?.close();
    return;
  }

  // Clicking the backdrop closes it, since the dialog fills only part of the
  // viewport and the area around it is still the dialog element itself.
  const modal = event.target.closest('[data-sizing-guide-modal]');
  if (modal && event.target === modal) modal.close();
});
